module.exports = __webpack_public_path__ + "static/media/grocery-store.b70cf0fe.jpg";